"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const CheckBox_1 = __importDefault(require("../CheckBox"));
function FormikCheckBox(props) {
    const { label, name, onChange = () => null, className = 'checkbox', reverse = false, style = { container: {}, label: {}, checkbox: {} }, defaultValue, renderLabel, ...resProps } = props;
    const { values, setFieldValue } = (0, formik_1.useFormikContext)();
    const value = reverse
        ? !(0, get_1.default)(values, name, defaultValue)
        : (0, get_1.default)(values, name, defaultValue);
    const changeHandler = (0, react_1.useCallback)((e) => {
        e.persist();
        onChange(e);
        void setFieldValue(name, reverse ? value : !value);
    }, [name, onChange, reverse, setFieldValue, value]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: `${className} check-${value}`, style: { display: 'flex', justifyContent: 'center', ...style.container }, children: [renderLabel?.(label), label && !renderLabel && ((0, jsx_runtime_1.jsx)("label", { htmlFor: name, className: "checkbox-label", style: style.label || {}, children: label })), (0, jsx_runtime_1.jsx)(CheckBox_1.default, { ...resProps, name: name, id: name, checked: value, onChange: changeHandler, style: style.checkbox || {} })] }));
}
exports.default = FormikCheckBox;
